import { useAppSelector } from "@/store";
import {
  isStudent,
  isProctor,
  isTeacher,
  isReviewer,
  isManager,
  isAdmin,
  hasManagerAccess,
} from "@/src/lib/auth";

/**
 * Hook for working with the current user's role
 *
 * @example
 * const { isStudent, isProctor, hasManagerAccess } = useUserRole();
 * if (hasManagerAccess) { ... }
 */
export const useUserRole = () => {
  const { user } = useAppSelector((state) => state.auth);

  return {
    user,
    isStudent: isStudent(user),
    isProctor: isProctor(user),
    isTeacher: isTeacher(user),
    isReviewer: isReviewer(user),
    isManager: isManager(user),
    isAdmin: isAdmin(user),
    hasManagerAccess: hasManagerAccess(user),
  };
};
